export function IsGravityBridge(zoneKey: string) {
  return zoneKey === 'gravity-bridge-3';
}
